import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DesktopCategoriesMenuNode } from '@main/categories-menu/const';
import { CategoriesMenuService } from '@main/categories-menu/data-access';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { DesktopCategoriesMenuComponentService } from './desktop-categories-menu.component.service';

@Component({
  selector: 'sd-desktop-categories-menu',
  templateUrl: './desktop-categories-menu.component.html',
  styleUrls: ['./desktop-categories-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DesktopCategoriesMenuComponentService],
  standalone: false,
})
export class DesktopCategoriesMenuComponent implements OnInit, OnDestroy {
  @Input() rootNodeId: string;

  isOpen$: Observable<boolean>;
  loading$: Observable<boolean>;
  nodes$: Observable<DesktopCategoriesMenuNode[]>;

  toggleOpen = this.categoriesMenuService.toggleOpen.bind(this.categoriesMenuService);
  changeNodesListWithDebounce = this.desktopCategoriesMenuComponentService.changeNodesListWithDebounce.bind(
    this.desktopCategoriesMenuComponentService,
  );
  changeNodesList = this.desktopCategoriesMenuComponentService.changeNodesList.bind(
    this.desktopCategoriesMenuComponentService,
  );
  isInNodesList = this.desktopCategoriesMenuComponentService.isInNodesList.bind(
    this.desktopCategoriesMenuComponentService,
  );

  private subscription = new Subscription();

  constructor(
    private desktopCategoriesMenuComponentService: DesktopCategoriesMenuComponentService,
    private categoriesMenuService: CategoriesMenuService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.changeNodesList(this.rootNodeId, 1, true);

    this.nodes$ = this.desktopCategoriesMenuComponentService.getNodes();

    this.subscription.add(
      this.router.events
        .pipe(filter((event: NavigationStart) => event instanceof NavigationStart))
        .subscribe(() => this.toggleOpen(false)),
    );

    this.isOpen$ = this.categoriesMenuService.isOpen$.pipe(
      tap((isOpen: boolean) => {
        if (!isOpen) {
          this.desktopCategoriesMenuComponentService.resetNodesList();
        }
      }),
    );

    this.loading$ = this.categoriesMenuService.getLoading();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
